import { Package, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ProductDetailsProps {
  value?: string;
  title?: string;
  sectionTitle?: string;
}

const ProductDetails = ({ value, title, sectionTitle }: ProductDetailsProps) => {
  const { t, i18n } = useTranslation();
  const dataTitle: string = title || t('order_pickup');
  const isRTL = i18n.language !== 'en';

  return (
    <div>
      {sectionTitle && (
        <span className='text-[11px] font-bold uppercase tracking-widest text-[rgb(115,123,140)] block mb-4'>
          {sectionTitle}
        </span>
      )}

      <div className='flex items-center justify-between bg-[rgb(245,245,243)] rounded-xl p-3.5'>
        <div className='flex items-center gap-2.5'>
          <Package size={18} className='text-[rgb(115,123,140)]' />
          <span className='text-[13px] font-medium text-[rgb(57,57,60)]'>{dataTitle}</span>
        </div>
        <div className='flex items-center gap-1.5'>
          <span className='text-[13px] font-bold text-[rgb(57,57,60)]'>{value || '—'}</span>
          <ChevronRight size={16} className={`text-[rgb(115,123,140)] ${isRTL ? 'rotate-180' : ''}`} />
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
